module.exports = require('./generated/crouton_types.js');;
